<!--
 * @Author: wang.zhiqin wang.zhiqin@trs.com.cn
 * @Date: 2023-06-26 14:03:01
 * @LastEditors: wang.zhiqin wang.zhiqin@trs.com.cn
 * @LastEditTime: 2025-09-24 16:03:00
 * @FilePath: \jsczt\src\views\home.vue
 * @Description: 部门预决算公开概览页
-->
<template>
  <div class="container" :style="{ zoom: scale }">
    <div class="content-wrapper">
      <top></top>
      <div class="current">
        当前位置：首页 > {{ cname }}
      </div>
      <div class="content">
        <div class="content_left">
          <leftTree :curnode="currNode" :cname="cname"  @curdata="getCurdata"></leftTree>
        </div>
        <div class="content_right">
          <div class="right_tab">
            <div class="year">
              <myYear @change="getYear" :year="year" @dateRange="getDateRange"></myYear>
            </div>
            <div class="place" @click="dqDialog = true">
            <myRegions :value="curplace"></myRegions>
            </div>
            <div class="places" v-if="hasBudw" @click="getBmvalue">
              <el-input v-model="bmvalue" placeholder="请选择" readonly></el-input>
            </div>
            <div class="places" v-if="dwoptions.length>0 && hasBudw" @click="getDwvalue">
              <el-input v-model="dwvalue" placeholder="请选择" readonly></el-input>
            </div>
            <div class="choose" @click="updateData">查询</div>
          </div>
          <div class="choice">
            <span style="margin-left: 20px;">
              已选择:
              <span style="margin-left: 15px;">年份:{{ showYear }}</span>
              <span v-if="choicePlace" style="margin-left: 15px;">地区:{{ choicePlace }}</span>
              <span v-if="bmName" style="margin-left: 15px;">部门:{{ bmName }}</span>
              <span v-if="dwName" style="margin-left: 15px;">单位:{{ dwName }} </span>
            </span>
          </div>
          <!-- 列表 -->
          <normalList :year="year" :classinfoid="this.$route.query.classinfoid" :list-data="listData" :place="choicePlace" :deptList="1"></normalList>
        </div>
        <div class="clear"></div>
      </div>
      <div class="footer">
        <div class="footercont">
          主办：江苏省财政厅 备案序号：苏ICP备15009401号
          公安备案号：32010602010331 网站标识码：3200000098 江苏省财政厅版权所有
          <div class="jiucuo">
            <span id="_span_jiucuo">
              <img @click="Link('3200000003')" style="border:0;cursor: pointer;" src="../assets/jiucuonew.png">
            </span>
          </div>
          <div class="dzjg">
            <span id="_ideConac">
              <a href="https://bszs.conac.cn/sitename?method=show&amp;id=105DF988641221CBE053012819ACE317" target="_blank">
                <img id="imgConac" vspace="0" hspace="0" border="0" src="../assets/red.png"></a>
              </span>
            </div>
        </div>
      </div>
    </div>

    <el-dialog
      :visible.sync="dqDialog"
      :append-to-body="true"
      class="my_dialog"
      style="background-color: none">
      <choiceDialog v-if="dialogVisible" @curtext="getcurText"  @close="getClose" :opentype="openType"></choiceDialog>
    </el-dialog>
    <!-- 部门 -->
    <el-dialog
      :visible.sync="bmDialog"
      :append-to-body="true"
      class="my_dialog"
      style="background-color: none">
      <bmDialog :bmoptions="bmoptions"  @curtext="getBmdata"  @close="getCloses"></bmDialog>
    </el-dialog>
    <!-- 单位 -->
    <el-dialog
      :visible.sync="dwDialog"
      :append-to-body="true"
      class="my_dialog"
      style="background-color: none">
      <bmDialog :bmoptions="dwoptions" @curtext="handledwData"  @close="getCloses"></bmDialog>
    </el-dialog>
  </div>
</template>

<script>
import myYear from '../components/myYear.vue'
import myRegions from '../components/myRegions.vue'
import top from '../components/top.vue'
import normalList from '../components/normalList.vue'
import leftTree from '../components/leftTree.vue'
import choiceDialog from '../components/choiceDialog.vue'
import bmDialog from '../components/bmDialog .vue'
export default {
  name: 'overview',
  components: {
    myYear,
    myRegions,
    normalList,
    top,
    leftTree,
    choiceDialog,
    bmDialog
  },
  data () {
    return {
      year: '',
      showYear: '',
      // 当前节点
      currNode: '',
      // 节点名称
      cname: '',
      dqDialog: false,
      dialogVisible: false,
      curplace: '',
      choicePlace: '',
      listData: [],
      fileType: '',
      areaCode: '',
      // 部门
      bmvalue: null,
      bmName: '',
      bmcode: '',
      // 单位
      dwvalue: null,
      dwName: '',
      dwcode: '',
      bmoptions: [],
      dwoptions: [],
      storageData: {},
      hasBudw: true,
      hasRange: false,
      bmDialog: false,
      dwDialog: false,
      curParentid: '',
      curBmid: '',
      trueYear: '',
      jsClassinfoid: ['28', '31', '18', '19', '20'],
      openType: 'ys',
      scale: 1 // 初始缩放比例
    }
  },
  computed: {
    getWindowSize () {
      return {
        width: window.innerWidth,
        height: window.innerHeight
      }
    }
  },
  watch: {
    dqDialog: {
      handler (val) {
        this.dialogVisible = val
      },
      deep: true,
      immediate: true
    },
    bmoptions: {
      handler (val) {
        if (val.length === 0) {
          this.dwoptions = []
        }
      },
      deep: true,
      immediate: true
    },
    currNode: {
      handler (val) {
        this.hasChilds(this.curParentid)
      },
      deep: true,
      immediate: true
    },
    scale: {
      handler (val) {
        window.addEventListener('load', this.handleResize)
      },
      deep: true,
      immediate: true
    },
    '$route.name': {
      handler (val) {
        this.handleResize()
      },
      deep: true,
      immediate: true
    }
  },
  mounted () {
    window.addEventListener('load', this.handleResize)
    window.addEventListener('resize', this.handleResize)
  },
  methods: {
    Link (sitecode) {
    // 该站点需要纠错页面的url地址
      var url = "http://yjsgk.jsczt.cn/#/"
      // 跳转至纠错系统填写页面
      window.open('http://121.43.68.40/exposure/jiucuo.html?site_code=' + sitecode + '&url=' + encodeURIComponent(url))
    },
    handleResize () {
      var width = this.getWindowSize.width
      // 假设你设计稿的宽度是 1920px
      var designWidth = 1920
      var scale = width / designWidth
      this.scale = scale.toFixed(2)
    },
    getClose (data) {
      if (data) {
        this.dqDialog = false
      }
    },
    getCloses (data) {
      if (data) {
        this.bmDialog = false
        this.dwDialog = false
      }
    },
    getDateRange (date) {
      if (date.split(',')[0]) {
        this.hasRange = true
        localStorage.setItem("rangeyear", date);
        // if (date.split(',')[0] < date.split(',')[1]) {
        //   localStorage.setItem('rangeyear', date.split(',')[1])
        // } else {
        //   localStorage.setItem('rangeyear', date.split(',')[0])
        // }
      }
    },
    getCurdata (item) {
      // console.log(item)
      // 清除头部的栏目名
      localStorage.setItem('topcname', '')
      this.currNode = item.classinfoid.toString()
      this.cname = item.cname
      if (this.currNode === '2' && this.showYear === this.trueYear.toString()) {
        this.curplace = ''
        this.bmvalue = ''
        this.dwvalue = ''
        this.bmName = ''
        this.choicePlace = ''
        return
      }
      this.listData = []
      if (this.curplace === '') {
        if (this.storageData.code !== '') {
          this.curplace = this.storageData.place
          this.areaCode = this.storageData.code
        }
      }
      this.bmvalue = localStorage.getItem('bmname')
      if (this.jsClassinfoid.includes(this.currNode)) {
        this.openType = 'js'
      } else {
        this.openType = 'ys'
      }
      // 更新路径数据
      var classinfoid = this.currNode
      var deptcode = this.bmcode
      var bmid = this.curBmid
      delete this.storageData.place
      this.$router.push({ name: 'overViewt', query: { classinfoid, deptcode, ...this.storageData, bmid } })
      this.getListdata()
      this.$http.post('/yjsUbas/yjs/add', {
        browserVersion:navigator.appVersion,
          browserName: navigator.appName,
          browserLanguage:navigator.language,
          areaCode:this.$route.query.code,
          areaName:this.choicePlace,
          deptCode:this.bmcode ? this.bmcode : '',
          deptName:localStorage.getItem('bmname'),
          unitCode:this.dwcode ? this.dwcode : '',
          unitName:localStorage.getItem('dwname'),
          areaYear:this.$route.query.year=='自定义'?localStorage.getItem('rangeyear'):this.$route.query.year,
          sourceType:6,
          fileType:item.classinfoid,
         
          url:window.location.href
        }).then(res => {
          }
        )
    },
    // 当前选中年份
    getYear (data) {
      this.year = data
      this.curplace = ''
      this.areaCode = ''
      this.bmvalue = ''
      this.dwvalue = ''
      this.hasBudw = false
      if (data !== '自定义') {
        localStorage.setItem('year', data)
        localStorage.setItem('rangeyear', '')
      }
    },
    // 当前选中地区
    getcurText (data) {
      this.areaCode = data.areacode
      this.storageData.parentid = data.chnlid
      this.curParentid = data.chnlid
      // 部门、单位字段清空
      this.bmvalue = ''
      this.bmName = ''
      this.dwvalue = ''
      this.bmcode = ''
      this.dwcode = ''
      // 地区赋值
      this.curplace = data.chnldesc
      if (data.close === false) {
        this.dqDialog = false
        this.hasBudw = true
      }
      this.hasChilds(data.chnlid, data.type)
    },
    // 部门
    getBmvalue () {
      this.bmDialog = true
    },
    getBmdata (data) {
      this.bmcode = data.code
      this.bmvalue = data.chnldesc
      this.curBmid = data.channelid
      this.areaCode = data.areacode
      // 单位清空
      this.dwcode = ''
      this.dwvalue = ''
      this.hasChilds(data.channelid, data.type)
      this.bmDialog = false
    },
    getDwvalue () {
      this.dwDialog = true
    },
    // 单位
    handledwData (data) {
      // const curdwData = this.dwoptions.find(item => item.channelid === data)
      this.dwvalue = data.chnldesc
      this.dwcode = data.code
      this.areaCode = data.areacode
      this.dwDialog = false
    },
    // 判断是否存在子集
    async hasChilds (id, type) {
      await this.$http.get('/api/wcmchannel/hasChild', {
        params: {
          parentId: id,
          classInfoId: this.currNode,
          isgroup: type === 2 ? 0 : 1
        }
      }).then(res => {
        if (res.data.code === 200) {
          this.hasBudw = true
          this.getbmDwList(id, type)
        }
      })
    },
    // 获取部门/单位
    async getbmDwList (id, type) {
      await this.$http.get('/api/wcmchannel/bmDwList', {
        params: {
          parentId: id,
          classInfoId: this.currNode,
          isgroup: type === 2 ? 0 : 1
        }
      }).then(res => {
        if (res.data.code === 200) {
          if (type === 2) {
            this.dwoptions = res.data.data
          } else {
            this.bmoptions = res.data.data
            const curdwData = this.bmoptions.find(item => item.channelid.toString() === this.$route.query.bmid)
            if (curdwData) {
              localStorage.setItem('bmname', curdwData.chnldesc)
              localStorage.setItem('bmcode', curdwData.deptcode)
            }
          }
        }
      })
    },
    updateData () {
      this.storageData.place = this.curplace
      this.storageData.code = this.areaCode
      this.storageData.year = this.showYear
      localStorage.setItem('key', JSON.stringify(this.storageData))
      localStorage.setItem('bmname', this.bmvalue)
      localStorage.setItem('dwname', this.dwvalue)
   
      // 更新路径数据
      var classinfoid = this.currNode
      var deptcode = this.bmcode
      var bmid = this.curBmid
      delete this.storageData.place
      this.$router.push({ name: 'overViewt', query: { classinfoid, deptcode, ...this.storageData, bmid } })
      this.getListdata()
    },
    async getListdata () {
      this.bmName = this.bmvalue
      this.dwName = this.dwvalue
      this.showYear = this.year
      this.choicePlace = this.curplace
      this.listData = []
      localStorage.setItem('ISdwname',0)
      if (this.areaCode === '') {
        this.$message({
          message: '行政区不能为空',
          type: 'error'
        })
      } else {
        if (this.dwvalue === '') {
          this.dwcode = ''
        }
        if (this.year != "自定义") {
          await this.$http.post('/api/yjsgk/findDataByFileType', {
          fileType: this.currNode,
          areaCode: this.areaCode,
          year: this.year,
          deptCode: this.bmcode ? this.bmcode : '',
          unitCode: this.dwcode ? this.dwcode : ''
        }, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }).then(res => {
          if (res.data.code === 200) {
            this.listData = res.data.data
            if(this.dwcode){
              localStorage.setItem('ISdwname', 1)
            }else{
              localStorage.setItem('ISdwname', 0)
            }
            
          }
        })
        } else {
          let Year = localStorage.getItem("rangeyear");
          if (Year.split(",")[0] > Year.split(",")[1]) {
            this.$message({
              message: "开始时间不能大于结束时间",
              type: "error",
            });
          } else {
            await this.$http.post('/api/yjsgk/findDataByFileType', {
          fileType: this.currNode,
          areaCode: this.areaCode,
          year:Year,
          deptCode: this.bmcode ? this.bmcode : '',
          unitCode: this.dwcode ? this.dwcode : ''
        }, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }).then(res => {
          if (res.data.code === 200) {
            this.listData = res.data.data
            if(this.dwcode){
              localStorage.setItem('ISdwname', 1)
            }else{
              localStorage.setItem('ISdwname', 0)
            }
            
          }
        })
          }
        }
      
      }
    },
    // 下载
    downLoad (data) {
      window.open(data[0].srcfile)
    },
    updateLocalStorageData () {
      this.storageData = JSON.parse(localStorage.getItem('key'))
      if (this.storageData) {
        this.bmvalue = localStorage.getItem('bmname')
        if (this.storageData.year === '自定义') {
          this.year = localStorage.getItem('rangeyear')
          this.showYear = this.year
        }
        // 左侧名称
        this.cname = this.storageData.cname
        // 地区
        this.curplace = this.storageData.place
        this.choicePlace = this.curplace
        this.curParentid = this.storageData.parentid
      }
      if (this.$route.query.classinfoid === '2') {
        this.cname = '部门决算'
      }
      // 数据
      if (this.cname === '部门决算' && this.trueYear === this.showYear) {
        console.log('未公开')
      } else {
        this.getListdata()
      }
      
    },
    isIdExists (treeData, code) {
      // 遍历树形数据的每个节点
      for (let i = 0; i < treeData.length; i++) {
        const node = treeData[i]
        if (node.code === code) {
          this.curplace = node.chnldesc
          return true
        }
        if (node.child && node.child.length > 0) {
          const isExists = this.isIdExists(node.child, code)
          if (isExists) {
            return true
          }
        }
      }
      return false
    },
    getcurArea () {
      this.currNode = this.$route.query.classinfoid
      if (this.jsClassinfoid.includes(this.currNode)) {
        this.openType = 'js'
      } else {
        this.openType = 'ys'
      }
      this.$http.get('/api/wcmchannel/findxzqh', {
        params: {
          year: this.year,
          openType: this.openType
        }
      }).then(res => {
        if (this.$route.query.code === res.data.data.code) {
          this.curplace = res.data.data.chnldesc
        } else {
          this.isIdExists(res.data.data.child, this.$route.query.code)
        }
        this.choicePlace = this.curplace
        var datas = {
          place: this.curplace,
          code: this.areaCode,
          year: this.year,
          parentid: this.$route.query.parentid
        }
        // 存储路径上的值
        localStorage.setItem('key', JSON.stringify(datas))
        // 判断是否存在单位
        if (this.$route.query.bmid) {
          this.hasChilds(this.$route.query.bmid, 2)
        }
        this.updateLocalStorageData()
      })
    }
  },
  created () {
    let date = new Date() // 获取当前时间
    this.trueYear = date.getFullYear() // 获取当前年份
    this.year = this.$route.query.year
    this.areaCode = this.$route.query.code
    this.showYear = this.year
    this.curParentid = this.$route.query.parentid
    this.bmcode = this.$route.query.deptcode
    this.getcurArea()
  }
}
</script>
<style scoped>
@import url('../assets/overview.css');
</style>



// WEBPACK FOOTER //
// src/views/overviewt.vue